import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
    twitterCard?: string;
}

const SEO: React.FC<SEOProps> = ({
    title = 'Podscope',
    description = 'Ranking y métricas de podcasts en Chile. Analiza estadísticas de audiencia, marcas auspiciadoras, views, interacciones e invitados. Herramientas de análisis de conversación digital.',
    image,
    url,
    type = 'website',
    twitterCard = 'summary_large_image',
}) => {
    const fullTitle = title.includes('Podscope') ? title : `${title} | Podscope`;
    // Normalize URL for canonical - remove query params and hash
    const normalizeUrl = (urlToNormalize: string): string => {
        try {
            const urlObj = new URL(urlToNormalize);
            return `${urlObj.origin}${urlObj.pathname}`;
        } catch {
            return urlToNormalize;
        }
    };
    const currentUrl = url ? normalizeUrl(url) : normalizeUrl(window.location.href);
    const imageUrl = image || `${window.location.origin}/logo192.png`;

    return (
        <Helmet>
            {/* Basic meta tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />

            {/* Open Graph meta tags */}
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="Podscope" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:secure_url" content={imageUrl} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={`${title} - Podscope`} />

            {/* Twitter Card meta tags */}
            <meta name="twitter:card" content={twitterCard} />
            <meta name="twitter:site" content="@podscope" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={imageUrl} />

            {/* Canonical URL */}
            <link rel="canonical" href={currentUrl} />
        </Helmet>
    );
};

export default SEO;
